//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ReviewCard from "@/components/shop/conf/ReviewCard";
import UiLazyImg from "@/components/Ui/UiLazyImg.vue";

export default {
  name: "Reviews",
  components: {
    Swiper,
    SwiperSlide,
    ReviewCard,
    UiLazyImg
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    productInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  async fetch() {
    await this.getReviews();
  },
  data() {
    return {
      loading: false,
      reviewList: [],
      swiperOption: {
        mousewheel: {
          forceToAxis: true
        },
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.pdp-swiper-custom-button-next',
          prevEl: '.pdp-swiper-custom-button-prev'
        },
        breakpoints: {
          921: {
            spaceBetween: 45,
            slidesPerView: 'auto',
          },
          700: {
            spaceBetween: 20,
            slidesPerView: 1.5,
          },
          320: {
            spaceBetween: 20,
            slidesPerView: 1.1,
          }
        }
      }
    }
  },
  computed: {
    requestedReviews() {
      return this.productInfo.reviews || [];
    }
  },
  methods: {
    async getReviews() {
      this.loading = true;
      const params = {};
      if (this.requestedReviews?.length) {
        params.ids = this.requestedReviews;
      }
      try {
        const { data } = await this.$axios.get('/reviews', {params});
        this.reviewList = data?.data || [];
      } catch (err) {
        console.log('error', err);
      }
      this.loading = false;
    },
  }
}
